module.exports = __webpack_public_path__ + "img/index-solutions-platform-hover.9dc85b00.png";